import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Content, Section, TextDiv } from "../../styles/Common";
import { styled } from "styled-components";
import OnePageLayout from "../../components/layout/OnePageLayout";
import HaveWallet from "../../components/amo/HaveWallet";
import DontHaveWallet from "../../components/amo/DontHaveWallet";
import { Loading } from "../../components/modal/Loading";
import { useDispatch, useSelector } from "react-redux";
import { getToken, returnLoginStatus } from "../../components/hooks/authFunc";
import { userActions } from "../../store/slices/userSlice";
import OnlyHeaderLayout from "../../components/layout/OnlyHeaderLayout";

const AmoPointChangeHome = () => {
  const dispatch = useDispatch();
  const accessToken = getToken();

  useEffect(() => {
    if (returnLoginStatus()) getData();
  }, []);

  const getData = () => {
    const params = {};
    dispatch(userActions.fetchUserLookup({ params, accessToken }));
  };
  const userInfo = useSelector((state) => state.user.userInfo);
  const wallet = userInfo.amoWallet;
  // console.log(userInfo, wallet);
  return (
    <OnlyHeaderLayout title="AMO 포인트 교환">
      {wallet ? <HaveWallet /> : <DontHaveWallet />}
    </OnlyHeaderLayout>
  );
};

export default AmoPointChangeHome;
